import { Formik, Field, Form, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import { GetQueryParam, EmailProviders } from '../Utils.js'
import { useEffect } from 'react';

const HubSpotForm = ({hubid, redirect, inline, first, last, phone, company, title, industry, industry_dnd, industry_ssc, country, state, zip, attendance, screenings, customer, catholic, comments_type, comments, consent, consent_color, partner, button, button_color}) => {
  const pageUrl = typeof window !== 'undefined' ? window.location.href : '';
  const pageTitle = document.title;

  let gclid = GetQueryParam('gclid');
  let utm_id = GetQueryParam('utm_id');
  let utm_campaign = GetQueryParam('utm_campaign');
  let utm_source = GetQueryParam('utm_source');
  let utm_medium = GetQueryParam('utm_medium');
  let utm_content = GetQueryParam('utm_content');
  let utm_term = GetQueryParam('utm_term');

  const initialValues = {
    firstname: '',
    lastname: '',
    honeypot: '',
    phone: '',
    company: '',
    country: '',
    state: '',
    zip: '',
    weekly_attendance: '',
    screenings_per_year: '',
    mb_customer: '',
    parish_or_diocese: '',
    questions_comments: '',
    jobtitle: '',
    industry: '',
    industry_dnd: '',
    industry_dnd_other: '',
    industry_ssc: '',
    mb_terms: true,
    url: pageUrl
  };

  let validationShape = {};

  if (utm_medium === 'cpc' || utm_medium ==='ppc') {
    validationShape.honeypot = Yup.string()
      .email('Must be a valid email')
      .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Incorrect format')
      .required('Required')
      .test('email', 'Please enter your business email address', (value) => {
        if (value) {
          return !EmailProviders.includes(value.split('@')[1])
        }
      })
  } else if (pageUrl.includes('highgroundsolutions.com')) {
    validationShape.honeypot = Yup.string()
      .email('Must be a valid email')
      .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Incorrect format')
      .required('Required')
      .test('email', 'In light of the excessive volume of spam, we have implemented a restriction that allows submissions exclusively from business email addresses. We appreciate your understanding in this matter.', (value) => {
        if (value) {
          return !EmailProviders.includes(value.split('@')[1])
        }
      })
  }  else {
    validationShape.honeypot = Yup.string()
      .email('Must be a valid email')
      .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Incorrect format')
      .required('Required')
  }

  if (first) {
    validationShape.firstname = Yup.string()
      .required('Required')
  }

  if (last) {
    validationShape.lastname = Yup.string()
      .required('Required')
  }

  if (phone) {
    validationShape.phone = Yup.string()
      .required('Required')
  }

  if (company) {
    validationShape.company = Yup.string()
      .required('Required')
  }

  if (country) {
    validationShape.country = Yup.string()
      .required('Required');
    validationShape.state = Yup.string()
      .required('Required')
  }

  if (state) {
    validationShape.state = Yup.string()
      .required('Required')
  }

  if (zip) {
    validationShape.zip = Yup.string()
      .matches(/^\d{5}([-]\d{4})?$/, 'Incorrect format')
      .required('Required')
  }

  if (attendance) {
    validationShape.weekly_attendance = Yup.string()
      .required('Required')
  }

  if (screenings) {
    validationShape.screenings_per_year = Yup.string()
      .required('Required')
  }

  if (customer) {
    validationShape.mb_customer = Yup.string()
      .required('Required')
  }

  if (catholic) {
    validationShape.parish_or_diocese = Yup.string()
      .required('Required')
  }

  if (comments || comments_type) {
    validationShape.questions_comments = Yup.string()
      .required('Required')
  }

  if (title) {
    validationShape.jobtitle = Yup.string()
      .required('Required')
  }

  if (industry) {
    validationShape.industry = Yup.string()
      .required('Required')
  }

  if (industry_dnd) {
    validationShape.industry_dnd = Yup.string()
      .required('Required')

    validationShape.industry_dnd_other = Yup.string()
      .when('industry_dnd', {
        is: 'Nonprofit-Other',
        then: (schema) => schema.required('Required'),
        otherWise: (schema) => schema.notRequired()
      })
  }

  if (industry_ssc) {
    validationShape.industry_ssc = Yup.string()
      .required('Required')
  }

  if (consent) {
    validationShape.mb_terms = Yup.bool()
      .oneOf([true], 'Required')
  }

  const validationSchema = Yup.object().shape(validationShape);

  function handleData(values) {
    let field = {};
    
    field = {
      email: values.honeypot
    }

    if (first) {
      field.firstname = values.firstname
    }

    if (last) {
      field.lastname = values.lastname
    }

    if (phone) {
      field.phone = values.phone
    }

    if (company) {
      field.company = values.company
    }

    if (title) {
      field.jobtitle = values.jobtitle
    }

    if (industry) {
      field.industry = values.industry
    }

    if (industry_dnd) {
      if (values.industry_dnd === 'Nonprofit-Other' && values.industry_dnd_other.length > 0) {
        field.industry = values.industry_dnd_other
      } else {
        field.industry = values.industry_dnd
      }
    }

    if (industry_ssc) {
      field.industry = values.industry_ssc
    }

    if (country) {
      field.country = values.country;
      field.state = values.state
    }

    if (state) {
      field.state = values.state
    }

    if (zip) {
      field.zip = values.zip
    }

    if (attendance) {
      field.total_worship_attendance = values.weekly_attendance
    }

    if (screenings) {
      field.screenings_per_year = values.screenings_per_year
    }

    if (customer) {
      field.are_you_a_current_customer_of_ministry_brands_ = values.mb_customer
    }

    if (catholic) {
      field.parish_or_diocese = values.parish_or_diocese
    }

    if (comments) {
      field.questions_comments = values.questions_comments
    }

    if (consent) {
      field.mb_t_c_accepted = values.mb_terms
    }

    if (partner) {
      field.partner_name = partner
    }

    if (gclid) {
      field.gclid = gclid
    }

    if (utm_id) {
      field.utm_id = utm_id
    }

    if (utm_campaign) {
      field.all___giv__utm_campaign = utm_campaign
    }

    if (utm_source) {
      field.all___giv__utm_source = utm_source
    }

    if (utm_medium) {
      field.all___giv__utm_medium = utm_medium
    }

    if (utm_content) {
      field.all___giv__utm_content = utm_content
    }

    if (utm_term) {
      field.all___giv__utm_term = utm_term
    }

    field.page_of_form_submission = pageUrl

    return {
      "submittedAt": Date.now(),
      "fields": Object.keys(field).map(key => ({
        name: key, value: field[key]
      })),
      "context": {
          "pageUri": pageUrl,
          "pageName": pageTitle
      }
    }
  }

  function handlePostSubmission() {
    if (redirect) {
      window.location.assign(redirect);
    } else if (inline && inline.length > 0) {
      document.getElementById('mb-hubspot').innerHTML = inline;
    } else if (inline) {
      document.getElementById('mb-hubspot').innerHTML = '<p>Thank you for your submission.</p>';
    } else {
      document.getElementById('mb-hubspot').innerHTML = '';
    }
  }

  async function submitToHubSpot(values) {
    try {
      const response = await fetch(`https://api.hsforms.com/submissions/v3/integration/submit/6060861/${hubid}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(handleData(values))
      });
  
      if (response.ok) {
        console.log('Form submitted successfully');
        handlePostSubmission();
        return true;
      } else {
        console.error('Form submission error:', response.status, response.statusText);
        return false;
      }
    } catch (error) {
      console.error('Network or API error:', error);
      return false;
    }
  }

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting }) => {
        if (values.name || values.url !== pageUrl) {
          console.log('Spam detected! Honeypot field was filled.');
          return;
        }
        console.log('Human submission, proceeding...');
        //alert(JSON.stringify(handleData(values)));
        submitToHubSpot(values);
      }}
    >
      {({ errors, touched, values }) => (
        <Form className="Form" autoComplete="off">
          {first &&
          <div>
            <label htmlFor="firstname">First Name</label>
            <Field name="firstname" type="text" placeholder="First Name" />
            <ErrorMessage name="firstname" render={msg => <span className="error">{msg}</span>} />
          </div>
          }

          {last &&
          <div>
            <label htmlFor="lastname">Last Name</label>
            <Field name="lastname" type="text" placeholder="Last Name" />
            <ErrorMessage name="lastname" render={msg => <span className="error">{msg}</span>} />
          </div>
          }
          
          <>
            <Field name="name" type="text" placeholder="Name" tabIndex="-1" autoComplete="off" className="x-input" />
            <ErrorMessage name="name" render={msg => <span className="error">{msg}</span>} />
          </>

          <div>
            <label htmlFor="honeypot">Email</label>
            <Field name="honeypot" type="email" placeholder="Email" />
            <ErrorMessage name="honeypot" render={msg => <span className="error">{msg}</span>} />
          </div>

          {phone &&
          <div>
            <label htmlFor="phone">Phone</label>
            <Field name="phone" type="tel" inputMode="numeric" pattern="[0-9]*" minLength="10" maxLength="10" placeholder="Phone" />
            <ErrorMessage name="phone" render={msg => <span className="error">{msg}</span>} />
          </div>
          }

          {company &&
          <div>
            <label htmlFor="company">{company === 'true' ? 'Company' : company}</label>
            <Field name="company" type="text" placeholder={company === 'true' ? 'Company' : company} />
            <ErrorMessage name="company" render={msg => <span className="error">{msg}</span>} />
          </div>
          }

          {title &&
          <div>
            <label htmlFor="jobtitle">{title === 'true' ? 'Job Title' : title}</label>
            <Field name="jobtitle" type="text" placeholder={title === 'true' ? 'Job Title' : title} />
            <ErrorMessage name="jobtitle" render={msg => <span className="error">{msg}</span>} />
          </div>
          }

          {industry &&
          <div>
            <label htmlFor="industry">{industry === 'true' ? 'Industry' : industry}</label>
            <Field name="industry" type="text" placeholder={industry === 'true' ? 'Industy' : industry} />
            <ErrorMessage name="industry" render={msg => <span className="error">{msg}</span>} />
          </div>
          }

          {industry_dnd &&
          <>
            <div>
              <label htmlFor="industry_dnd">{industry_dnd === 'true' ? 'Industry' : industry_dnd}</label>
              <Field name="industry_dnd" as="select">
                <option value="">{industry_dnd === 'true' ? 'Industry' : industry_dnd}</option>
                <option value="Nonprofit-Missions, Evangelism, & Sponsorships">Missions, Evangelism, & Sponsorships</option>
                <option value="Nonprofit-Faith-Based Education & Growth">Faith-Based Education & Growth</option>
                <option value="Nonprofit-Media & Broadcasting">Media & Broadcasting</option>
                <option value="Nonprofit-Relief & Community Services">Relief & Community Services</option>
                <option value="Nonprofit-Foundation">Foundation</option>
                <option value="Nonprofit-Advocacy">Advocacy</option>
                <option value="Nonprofit-Other">Other</option>
              </Field>
              <ErrorMessage name="industry_dnd" render={msg => <span className="error">{msg}</span>} />
            </div>

            {values.industry_dnd === 'Nonprofit-Other' && (
              <div>
                <label htmlFor="industry_dnd_other">Please tell us your nonprofit type</label>
                <Field name="industry_dnd_other" type="text" placeholder="Please tell us your nonprofit type" />
                <ErrorMessage name="industry_dnd_other" render={msg => <span className="error">{msg}</span>} />
              </div>
            )}
          </>
          }

          {industry_ssc &&
          <>
            <div>
              <label htmlFor="industry_ssc">{industry_ssc === 'true' ? 'Industry' : industry_ssc}</label>
              <Field name="industry_ssc" as="select">
                <option value="">{industry_ssc === 'true' ? 'Industry' : industry_ssc}</option>
                <option value="Aerospace">Aerospace</option>
                <option value="Association">Association</option>
                <option value="Business Services">Business Services</option>
                <option value="Construction">Construction</option>
                <option value="Education">Education</option>
                <option value="Energy">Energy</option>
                <option value="Finance">Finance</option>
                <option value="Food & beverage">Food & beverage</option>
                <option value="Government">Government</option>
                <option value="Healthcare">Healthcare</option>
                <option value="Hospitality/Entertainment">Hospitality/Entertainment</option>
                <option value="Industrial">Industrial</option>
                <option value="Insurance">Insurance</option>
                <option value="Legal">Legal</option>
                <option value="Manufacturing">Manufacturing</option>
                <option value="Media Broadcast">Media Broadcast</option>
                <option value="Not For Profit">Not For Profit</option>
                <option value="Real Estate">Real Estate</option>
                <option value="Staffing/HR">Staffing/HR</option>
                <option value="Technology">Technology</option>
                <option value="Transportation">Transportation</option>
                <option value="Youth Sports">Youth Sports</option>
              </Field>
              <ErrorMessage name="industry_ssc" render={msg => <span className="error">{msg}</span>} />
            </div>
          </>
          }

          {country &&
          <div>
            <label htmlFor="country">Country</label>
            <Field name="country" as="select">
              <option value="">Country</option>
              <option value="CA">Canada</option>
              <option value="US">United States</option>
            </Field>
            <ErrorMessage name="country" render={msg => <span className="error">{msg}</span>} />
          </div>
          }

          {(country || state) &&
          <div>
            <label htmlFor="state">{values.country === 'CA' ? 'Province/Territory' : 'State'}</label>
            <Field name="state" as="select">
              <option value="">{values.country === 'CA' ? 'Province/Territory' : 'State'}</option>

              {values.country === 'CA' ?
              <>
                <option value="AB">Alberta</option>
                <option value="BC">British Columbia</option>
                <option value="MB">Manitoba</option>
                <option value="NB">New Brunswick</option>
                <option value="NL">Newfoundland and Labrador</option>
                <option value="NT">Northwest Territories</option>
                <option value="NS">Nova Scotia</option>
                <option value="NU">Nunavut</option>
                <option value="ON">Ontario</option>
                <option value="PE">Prince Edward Island</option>
                <option value="QC">Quebec</option>
                <option value="SK">Saskatchewan</option>
                <option value="YT">Yukon</option>
              </>
              :
              <>
                <option value="AL">Alabama</option>
                <option value="AK">Alaska</option>
                <option value="AZ">Arizona</option>
                <option value="AR">Arkansas</option>
                <option value="CA">California</option>
                <option value="CO">Colorado</option>
                <option value="CT">Connecticut</option>
                <option value="DE">Delaware</option>
                <option value="DC">District of Columbia</option>
                <option value="FL">Florida</option>
                <option value="GA">Georgia</option>
                <option value="HI">Hawaii</option>
                <option value="ID">Idaho</option>
                <option value="IL">Illinois</option>
                <option value="IN">Indiana</option>
                <option value="IA">Iowa</option>
                <option value="KS">Kansas</option>
                <option value="KY">Kentucky</option>
                <option value="LA">Louisiana</option>
                <option value="ME">Maine</option>
                <option value="MD">Maryland</option>
                <option value="MA">Massachusetts</option>
                <option value="MI">Michigan</option>
                <option value="MN">Minnesota</option>
                <option value="MS">Mississippi</option>
                <option value="MO">Missouri</option>
                <option value="MT">Montana</option>
                <option value="NE">Nebraska</option>
                <option value="NV">Nevada</option>
                <option value="NH">New Hampshire</option>
                <option value="NJ">New Jersey</option>
                <option value="NM">New Mexico</option>
                <option value="NY">New York</option>
                <option value="NC">North Carolina</option>
                <option value="ND">North Dakota</option>
                <option value="OH">Ohio</option>
                <option value="OK">Oklahoma</option>
                <option value="OR">Oregon</option>
                <option value="PA">Pennsylvania</option>
                <option value="RI">Rhode Island</option>
                <option value="SC">South Carolina</option>
                <option value="SD">South Dakota</option>
                <option value="TN">Tennessee</option>
                <option value="TX">Texas</option>
                <option value="UT">Utah</option>
                <option value="VT">Vermont</option>
                <option value="VA">Virginia</option>
                <option value="WA">Washington</option>
                <option value="WV">West Virginia</option>
                <option value="WI">Wisconsin</option>
                <option value="WY">Wyoming</option>
              </>
              }
            </Field>
            <ErrorMessage name="state" render={msg => <span className="error">{msg}</span>} />
          </div>
          }

          {zip &&
          <div>
            <label htmlFor="zip">Zip Code</label>
            <Field name="zip" type="text" placeholder="Zip Code" />
            <ErrorMessage name="zip" render={msg => <span className="error">{msg}</span>} />
          </div>
          }

          {attendance &&
            <div>
              <label htmlFor="weekly_attendance">Total Weekly Attendance</label>
              <Field name="weekly_attendance" as="select">
                <option value="">Total Weekly Attendance</option>
                <option value="100">100 or less</option>
                <option value="249">101-249</option>
                <option value="499">250-499</option>
                <option value="999">500-999</option>
                <option value="1999">1000-1999</option>
                <option value="4999">2000-4999</option>
                <option value="9999">5000-9999</option>
                <option value="10000">10,000 or more</option>
              </Field>
              <ErrorMessage name="weekly_attendance" render={msg => <span className="error">{msg}</span>} />
            </div>
          }

          {screenings &&
            <div>
              <label htmlFor="screenings_per_year">Screenings Per Year</label>
              <Field name="screenings_per_year" type="text" placeholder="Screenings Per Year" />
              <ErrorMessage name="screenings_per_year" render={msg => <span className="error">{msg}</span>} />
            </div>
          }

          {customer &&
          <div>
            <label htmlFor="mb_customer">Are you a current customer of Ministry Brands?</label>
            <Field name="mb_customer" as="select">
              <option value="">Are you a current customer of Ministry Brands?</option>
              <option value="Is Customer">I am a current customer of Ministry Brands</option>
              <option value="Is Not Customer">I am not a current customer (or I don't know)</option>
            </Field>
            <ErrorMessage name="mb_customer" render={msg => <span className="error">{msg}</span>} />
          </div>
          }

          {catholic &&
          <div>
            <label htmlFor="parish_or_diocese">Are you a Parish or a Diocese?</label>
            <Field name="parish_or_diocese" as="select">
              <option value="">Are you a Parish or a Diocese?</option>
              <option value="Parish">Parish</option>
              <option value="Diocese">Diocese</option>
            </Field>
            <ErrorMessage name="parish_or_diocese" render={msg => <span className="error">{msg}</span>} />
          </div>
          }

          {(comments || comments_type) &&
            <div>
              <label htmlFor="questions_comments">{(comments === undefined || comments === 'true') ? 'How did you hear about us?' : comments}</label>
              <Field name="questions_comments" type="text" as={comments_type === 'textarea' ? 'textarea' : ''} placeholder={(comments === undefined || comments === 'true') ? 'How did you hear about us?' : comments} />
              <ErrorMessage name="questions_comments" render={msg => <span className="error">{msg}</span>} />
            </div>
          }

          {(consent && consent === "true") &&
            <div>
              <label htmlFor="mb_terms" style={{display: 'block', height: 'auto', visibility: 'visible', marginBottom: '1rem', color: consent_color}}>
                <Field name="mb_terms" type="checkbox" style={{marginRight: '0.5em'}} />
                I accept the <a href="https://legal.ministrybrands.com/" target="_blank">Terms and Conditions</a>
              </label>
              <ErrorMessage name="mb_terms" render={msg => <span className="error">{msg}</span>} />
            </div>
          }

          {(consent && consent.length > 4) &&
            <div>
              <label htmlFor="mb_terms" style={{display: 'block', height: 'auto', visibility: 'visible', marginBottom: '1rem', color: consent_color}}>
                <Field name="mb_terms" type="checkbox" style={{marginRight: '0.5em'}} />
                {consent}
              </label>
              <ErrorMessage name="mb_terms" render={msg => <span className="error">{msg}</span>} />
            </div>
          }
          
          <>
            <Field name="url" type="text" placeholder="URL" tabIndex="-1" autoComplete="off" className="x-input" />
            <ErrorMessage name="url" render={msg => <span className="error">{msg}</span>} />
          </>

          <div style={{textAlign: 'center'}}>
            <button type="submit" className="Btn" style={{backgroundColor: button_color}}>
              {button ? button : 'Submit'}
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default HubSpotForm;
